import { useState } from "react";

// Kruhový avatar s fotkou; při chybě/absenci fotky zobrazí iniciály na zeleno‑navy gradientu.
export const Avatar = ({ src, name = "", initials, className = "" }) => {
  const [err, setErr] = useState(false);
  const derived =
    initials ||
    name
      .replace(/[^\p{L}\s]/gu, "")
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0])
      .join("")
      .toUpperCase();

  const showImg = src && !err;

  return (
    <div
      className={`w-24 h-24 rounded-full overflow-hidden mx-auto ring-4 ring-white shadow-[0_10px_24px_-10px_rgba(27,42,78,0.5)] ${className}`}
    >
      {showImg ? (
        <img src={src} alt={name} loading="lazy" onError={() => setErr(true)} className="w-full h-full object-cover" />
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-gavito-green to-gavito-navy flex items-center justify-center">
          <span className="text-white font-heading font-extrabold text-2xl tracking-wide">{derived}</span>
        </div>
      )}
    </div>
  );
};
